/**
 * Currency PropTypes
 *
 * PropType definitions for currency and pricing-related components.
 * Used in cart, checkout, and product display components.
 *
 * @module propTypes/currency
 */

import PropTypes from "prop-types";

/**
 * Currency shape
 * Represents currency information with symbol and exchange rate
 *
 * @property {string} currencySymbol - Currency symbol (e.g., "€", "$", "£")
 * @property {number} currencyRate - Exchange rate for currency conversion
 */
export const currencyShape = PropTypes.shape({
  currencySymbol: PropTypes.string.isRequired,
  currencyRate: PropTypes.number.isRequired,
});
